
<section class="content" v-html="block.content.html"></section>
